import { ChevronSmallRightIcon, ChevronSmallLeftIcon, ChevronSmallDownIcon, CalendarIcon, ClockIcon } from '../../icons/index.js';
import { jsx } from 'react/jsx-runtime';

const MuiDatePickerOverrides = {
  MuiPickersTextField: {
    defaultProps: {
      variant: 'filled'
    }
  },
  MuiPickersFilledInput: {
    styleOverrides: {
      root: ({
        theme
      }) => ({
        backgroundColor: theme.palette.background.default,
        ':hover, &.Mui-focused': {
          backgroundColor: theme.palette.background.default
        },
        ':after': {
          borderBottom: `2px solid  ${theme.palette.gray80}`
        },
        ':before': {
          borderBottom: `2px solid  ${theme.palette.divider}`
        },
        '&:hover:not(.Mui-disabled, .Mui-error):before': {
          borderBottom: `2px solid  ${theme.palette.text.disabled}`
        }
      }),
      sectionsContainer: ({
        theme
      }) => ({
        padding: theme.spacing(1.25, 1.5),
        '.MuiPickersSectionList-section': {
          ...theme.typography.body01
        }
      })
    }
  },
  MuiDatePicker: {
    defaultProps: {
      slots: {
        openPickerIcon: CalendarIcon,
        switchViewIcon: ChevronSmallDownIcon
      },
      slotProps: {
        openPickerButton: {
          edge: 'start'
        }
      }
    }
  },
  MuiDateTimePicker: {
    defaultProps: {
      ampm: false,
      slots: {
        openPickerIcon: CalendarIcon,
        switchViewIcon: ChevronSmallDownIcon
      },
      slotProps: {
        openPickerButton: {
          edge: 'start'
        }
      }
    }
  },
  MuiPickersArrowSwitcher: {
    defaultProps: {
      slots: {
        leftArrowIcon: ChevronSmallLeftIcon,
        rightArrowIcon: ChevronSmallRightIcon
      }
    },
    styleOverrides: {
      root: ({
        theme
      }) => ({
        '.MuiTypography-subtitle1': {
          ...theme.typography.body02
        }
      })
    }
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      label: ({
        theme
      }) => ({
        ...theme.typography.body02
      })
    }
  },
  MuiYearCalendar: {
    styleOverrides: {
      root: ({
        theme
      }) => ({
        '.MuiYearCalendar-button': {
          ...theme.typography.body01
        }
      })
    }
  },
  MuiDateTimePickerTabs: {
    defaultProps: {
      timeIcon: /*#__PURE__*/jsx(ClockIcon, {}),
      dateIcon: /*#__PURE__*/jsx(CalendarIcon, {})
    }
  },
  MuiPickersToolbar: {
    styleOverrides: {
      root: ({
        theme
      }) => ({
        '.MuiTypography-overline': {
          ...theme.typography.caption
        },
        '.MuiTypography-root': {
          fontFamily: theme.typography.fontFamily
        }
      })
    }
  }
};

export { MuiDatePickerOverrides };
